module.exports = __webpack_public_path__ + "static/doubledegree1-fb5ff33cfc10f929913589178cbad9e1.jpeg";